import {
  ApplicationInsights,
  DistributedTracingModes,
  IEventTelemetry, IExceptionTelemetry,
  IPageViewTelemetry,
  ITelemetryItem,
} from '@microsoft/applicationinsights-web';
import AuthorizationModuleFacade from 'shared/src/modules/authModule/store/authorizationModule.facade';

export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: window.appSettings.App.AppInsightsInstrumentationKey,
    enableAutoRouteTracking: false,
    enableCorsCorrelation: true,
    distributedTracingMode: DistributedTracingModes.W3C,
  },
});
appInsights.loadAppInsights();
appInsights.setAuthenticatedUserContext(AuthorizationModuleFacade.UserMid || '');

const telemetryInitializer: (item: ITelemetryItem) => boolean | void = (
  envelope: ITelemetryItem
) => {

  if (envelope?.baseData?.target?.indexOf('sockjs-node') > -1) {
    return false;
  }

  const regex = new RegExp('eUSMobile(?:/([^s]*))?(?=s|$)');
  const matches = regex.exec(window.navigator.userAgent);

  if(matches && matches.length > 1) {
    const telemetryItem = envelope?.data;
    if (telemetryItem !== undefined) {
      telemetryItem['MobileAppVersion'] = matches[1];
    }
  }

  if (envelope) {
    if (!envelope.tags) {
      envelope.tags = [];
    }

    if (!envelope.tags['ai.cloud.role']) {
      envelope.tags.push({
        'ai.cloud.role': window.appSettings.Sso.ClientId,
      });
    }
  }
};

appInsights.addTelemetryInitializer(telemetryInitializer);

export const trackPageView = (event: IPageViewTelemetry): void => {
  appInsights.trackPageView(event);
  appInsights.flush();
};

export enum IS_ORGANIZATION {
  TRUE = 'True',
  FALSE = 'False'
}

export const sendCustomEvent = (event: IEventTelemetry, isOrganization: IS_ORGANIZATION = IS_ORGANIZATION.FALSE): void => {
  // Sending string to match BE format
  appInsights.trackEvent(event, { isOrganization });
  appInsights.flush();
};

export const sendExceptionEvent = (event: IExceptionTelemetry): void => {
  appInsights.trackException(event);
  appInsights.flush();
};